import GameSettings from "../GameSettings";

export function isMobileDevice(scene: Phaser.Scene): boolean {
  if (GameSettings.mobileOverride === "mobile") return true;
  if (GameSettings.mobileOverride === "pc") return false;
  const os = scene.sys.game.device.os;
  return !!(os.android || os.iOS || os.iPad || os.iPhone);
}
